// extracted by css-extract-rspack-plugin
export default {"isDisabled":"home-fragment__Common_isDisabled__Bs4iW","hiddenLegend":"home-fragment__Common_hiddenLegend__lQXif","isSmall":"home-fragment__Common_isSmall__QQVoD"};